import React, {Component} from 'react';
import Header from './Header';
import Navigation from './Navigation';
import Favicon from 'react-favicon';
let faviconIco = require('../images/favicon.ico');

class App extends Component {
   render() {
      return (
         <div>
            <Favicon url={faviconIco} />
            <div className="container">
               <Header/>
               <Navigation/>
            </div>
         </div>
      );
   }
}

export default App;



// WEBPACK FOOTER //
// ./src/components/App.js